import React from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { mobile } from "../responsive";
import CloseRounded from "@mui/icons-material/CloseRounded";
const HighlightsContainer = styled.div`
  width: 600px;
  ${mobile({ width: "300px" })}

  li {
    font-size: 0.8rem;
    margin: 0.5rem 0;
    display: flex;
    column-gap: 0.3rem;

    button {
      opacity: 0;
      transition: all 0.2s ease-in-out;
    }

    &:hover {
      button {
        opacity: 1;
      }
    }
  }

  ul {
    margin-bottom: 2rem;
  }
  form {
    display: flex;
    flex-direction: column;
    textarea {
      margin-top: 0.5rem;
    }
    .hl-btn {
      border: solid 1px black;
      border-radius: 30px;
      cursor: pointer;
      margin: 1rem 0;
      padding: 0.7rem;
      width: 8rem;
    }
  }
`;

function HL({ keyword, setHL, hl, isLocked }) {
  const { register, handleSubmit, reset } = useForm();
  const onSubmitHL = (data) => {
    setHL([...hl, data.hl]);
    reset();
  };
  const deleteHL = (i) => {
    setHL(hl.filter((v, index) => i !== index));
  };
  const button =
    keyword === "Highlights" ? "+ Add Highlight" : `+ Add Learning`;

  return (
    <HighlightsContainer>
      <form onSubmit={handleSubmit(onSubmitHL)}>
        <h2>Can we note any {keyword}?</h2>
        <textarea
          placeholder="Start typing..."
          disabled={isLocked}
          {...register("hl", { maxLength: 250 })}
        ></textarea>
        <input className="hl-btn" type="submit" value={button} />
      </form>
      <ul>
        {hl.map((v, i) => {
          return (
            <li key={i}>
              <button
                onClick={() => {
                  deleteHL(i);
                }}
              >
                <CloseRounded color="primary" sx={{ fontSize: 18 }} />
              </button>
              "{v}"
            </li>
          );
        })}
      </ul>
    </HighlightsContainer>
  );
}

export default HL;
